// NOTE: not integrated with backend
// engagement meter component is smiler to single row heatmap
// four levels of engagement
// 0. no data
// 1. low
// 2. medium
// 3. high
// input int array
import React, { useState, useEffect } from 'react';
import { Box, Tooltip } from '@mui/material';
import { formatNumberToStringMonthWithoutYear } from '../../utils/dateUtils';
import i18n from '../../i18n';

export interface IEngagementMeterProps {
  engageData: {
    date: string;
    engagementLevel: string;
  }[];
  size?: number;
}

const getDateMap = () => {
  const dateMap = new Map();
  for (let i = 0; i < 14; i += 1) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const dateString = date.toISOString().split('T')[0];
    dateMap.set(dateString, 'NO_DATA');
  }
  return dateMap;
};

export const engagmentLevel = {
  NO_DATA: '/assets/icons/no-data.svg',
  NONE: '/assets/icons/low-engagement.svg',
  PARTIAL: '/assets/icons/average-engagement.svg',
  FULL: '/assets/icons/good-engagement.svg',
};

export const engagmentLevels = {
  NO_DATA: 'clientTable.engagementLevels.noData',
  NONE: 'clientTable.engagementLevels.low',
  PARTIAL: 'clientTable.engagementLevels.average',
  FULL: 'clientTable.engagementLevels.good',
};

const EngagementMeter = ({ engageData, size = 16 }: IEngagementMeterProps) => {
  const [engagementData, setEngagementData] = useState(getDateMap());

  useEffect(() => {
    const dateMap = getDateMap();
    engageData.forEach((data) => {
      dateMap.set(data.date.split('T')[0], data.engagementLevel);
    });
    setEngagementData(dateMap);
  }, [engageData]);
  return (
    <Box
      display="flex"
      gap="25px"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      pr="24px"
    >
      <Box display="flex" gap="4px">
        {Array.from(engagementData, ([date, data]) => (
          <Tooltip
            key={date}
            title={`${formatNumberToStringMonthWithoutYear(date)} - ${i18n.t(
              engagmentLevels[data as keyof typeof engagmentLevels]
            )}`}
            placement="top"
            arrow
            componentsProps={{
              tooltip: {
                sx: {
                  bgcolor: 'primary.main',
                  borderRadius: '5px',
                  padding: '8px 12px',
                },
              },
              arrow: {
                sx: {
                  '&:before': {
                    bgcolor: 'primary.main',
                  },
                },
              },
            }}
          >
            <img
              src={engagmentLevel[data as keyof typeof engagmentLevel]}
              alt={data}
              style={{ height: size, width: size }}
            />
          </Tooltip>
        )).reverse()}
      </Box>
    </Box>
  );
};

export default EngagementMeter;
